(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("openseadragon"));
	else if(typeof define === 'function' && define.amd)
		define(["openseadragon"], factory);
	else if(typeof exports === 'object')
		exports["openseadragon-viewerinputhook"] = factory(require("openseadragon"));
	else
		root["openseadragon-viewerinputhook"] = factory(root["openseadragon"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 